import { RequestOptions } from '@gridscale/gsclient-js';
import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as _ from 'lodash';
import * as fromPartnerProjects from './projects.reducer';

export const selectPartnerProjectsState = createFeatureSelector<fromPartnerProjects.State>(
  fromPartnerProjects.featureKey
);

const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = fromPartnerProjects.adapter.getSelectors();

const listSelectors = fromPartnerProjects.listAdapter.getSelectors((state: fromPartnerProjects.State) => state.list);
const listForLocationSelectors = (props: { locationUuid: string }) => fromPartnerProjects.listForLocationAdapter.getSelectors((state: fromPartnerProjects.State) => _.get(state.listForLocation, props.locationUuid, fromPartnerProjects.listForLocationAdapterInitialState));

/**
 * Get list config (sorting etc.)
 */
export const getListConfig = createSelector(
  selectPartnerProjectsState,
  (state: fromPartnerProjects.State) => state?.list?.listConfig
);

/**
 * Get current search string
 */
export const getSearch = createSelector(
  selectPartnerProjectsState,
  (state: fromPartnerProjects.State) => _.get(state, ['list', 'search'])
);


/**
 * Get Project list
 */
export const getProjects = createSelector(
  selectPartnerProjectsState,
  listSelectors.selectAll
);

/**
 * Get Project total in store
 */
export const getProjectsTotalInStore = createSelector(
  selectPartnerProjectsState,
  listSelectors.selectTotal
);

/**
 * Get VirtualSwitches list meta data (total etc.)
 */
export const getProjectsMeta = createSelector(
  selectPartnerProjectsState,
  (state: fromPartnerProjects.State) => _.get(state, ['list', 'meta'], { total: 0, count: 0, offset: 0, limit: 0, page: 0 })
);

/**
 * selects if there are more projects to load
 */
export const hasProjectsNext = createSelector(
  selectPartnerProjectsState,
  getProjectsTotalInStore,
  getProjectsMeta,
  (state: fromPartnerProjects.State, total, meta) => _.get(meta, 'total', 0) > total
)

/**
 * selects if there was an error
 */
export const hasProjectsError = createSelector(
  selectPartnerProjectsState,
  (state: fromPartnerProjects.State) => !!_.get(state, 'list.error')
)

/**
 * Get VirtualSwitches list meta data (total etc.)
 */
export const getProjectsLinks = createSelector(
  selectPartnerProjectsState,
  (state: fromPartnerProjects.State) => _.get(state, ['list', 'links'])

);

/**
 * Get if VirtualSwitches list is loading
 */
export const isPartnerProjectsListLoading = createSelector(
  selectPartnerProjectsState,
  (state: fromPartnerProjects.State) => _.get(state, ['list', 'loading'], false)

);

/**
 * Get if VirtualSwitches list is loading next bunch of data
 */
export const isPartnerProjectsListLoadingNext = createSelector(
  selectPartnerProjectsState,
  (state: fromPartnerProjects.State) => _.get(state, ['list', 'loadingNext'], false)

);

/**
 * get if VirtualSwitches list is loaded
 */
export const isPartnerProjectsListLoaded = createSelector(
  selectPartnerProjectsState,
  (state: fromPartnerProjects.State) => _.get(state, ['list', 'loaded'], false)

);


export const getPartnerProject = (props: { uuid: string }) => createSelector(
  selectPartnerProjectsState,
  (state: fromPartnerProjects.State) => _.get(selectEntities(state), [props.uuid])
);

export const isPartnerProjectLoading = (props: { uuid: string }) => createSelector(
  selectPartnerProjectsState,
  (state: fromPartnerProjects.State) => _.get(state, ['loading', props.uuid], false)
);

export const isPartnerProjectLoaded = (props: { uuid: string }) => createSelector(
  selectPartnerProjectsState,
  (state: fromPartnerProjects.State) => _.get(state, ['loaded', props.uuid], false)
);

export const isPartnerProjectBusy = (props: { uuid: string }) => createSelector(
  selectPartnerProjectsState,
  (state: fromPartnerProjects.State) => _.get(state, ['loading', props.uuid], false) || _.get(state, ['patching', props.uuid], false) || _.get(state, ['deleting', props.uuid], false)
);









/**
 * Get Project list
 */
export const getProjectsForLocation = (props: { locationUuid: string }) => createSelector(
  selectPartnerProjectsState,
  listForLocationSelectors(props).selectAll
);

/**
 * Get Project total in store
 */
export const getProjectsForLocationTotalInStore = (props: { locationUuid: string }) => createSelector(
  selectPartnerProjectsState,
  listForLocationSelectors(props).selectTotal
);

/**
 * Get VirtualSwitches list meta data (total etc.)
 */
export const getProjectsForLocationMeta = (props: { locationUuid: string }) => createSelector(
  selectPartnerProjectsState,
  (state: fromPartnerProjects.State) => _.get(state, ['listForLocation', props.locationUuid, 'meta'])
);

/**
 * selects if there are more projects to load
 */
export const hasProjectsForLocationNext = (props: { locationUuid: string }) => createSelector(
  selectPartnerProjectsState,
  getProjectsForLocationTotalInStore(props),
  getProjectsForLocationMeta(props),
  (state: fromPartnerProjects.State, total, meta) => _.get(meta, 'total', 0) > total
)

/**
 * selects if there was an error
 */
export const hasProjectsForLocationError = (props: { locationUuid: string }) => createSelector(
  selectPartnerProjectsState,
  (state: fromPartnerProjects.State) => !!_.get(state, ['listForLocation', props.locationUuid, 'error'])
)

/**
 * Get VirtualSwitches list meta data (total etc.)
 */
export const getProjectsForLocationLinks = (props: { locationUuid: string }) => createSelector(
  selectPartnerProjectsState,
  (state: fromPartnerProjects.State) => _.get(state, ['listForLocation', props.locationUuid, 'links'])

);

/**
 * Get if VirtualSwitches list is loading
 */
export const isPartnerProjectsForLocationListLoading = (props: { locationUuid: string }) => createSelector(
  selectPartnerProjectsState,
  (state: fromPartnerProjects.State) => _.get(state, ['listForLocation', props.locationUuid, 'loading'], false)

);

/**
 * Get if VirtualSwitches list is loading next bunch of data
 */
export const isPartnerProjectsForLocationListLoadingNext = (props: { locationUuid: string }) => createSelector(
  selectPartnerProjectsState,
  (state: fromPartnerProjects.State) => _.get(state, ['listForLocation', props.locationUuid, 'loadingNext'], false)

);

/**
 * get if VirtualSwitches list is loaded
 */
export const isPartnerProjectsForLocationListLoaded = (props: { locationUuid: string }) => createSelector(
  selectPartnerProjectsState,
  (state: fromPartnerProjects.State) => _.get(state, ['listForLocation', props.locationUuid, 'loaded'], false)

);
